module.exports = __webpack_public_path__ + "static/media/emj18.78519b25.svg";